module.exports = __webpack_public_path__ + "assets/img/es-790f1ce0.png";